import { CONFIG as config } from '../config';
import { buildUrl } from '../utils';
import {
  HaclMapperMsgConversionApi,
  ComputedPatch,
} from './HaclMapperMsgConversionApi';
import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';

/** @public */
export class HaclMapperMsgConversionClient
  implements HaclMapperMsgConversionApi
{
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async decodeHaclToJson(
    appliancePncElc: string,
    hacl: string,
  ): Promise<ComputedPatch> {
    const url = buildUrl(config.baseUrl, {
      path: `/hacl/decode`,
      queryParams: { appliancePncElc, hacl },
    });

    const response = await this.get(url);
    return response.body;
  }

  async get(path: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl('proxy')}${path}`;
    const { token: idToken } = await this.identityApi.getCredentials();

    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
      },
      method: 'GET',
    });

    if (!response.ok) {
      const body = await response.text();
      const message = `Request failed with ${response.status} ${response.statusText}, ${body}`;
      throw new Error(message);
    }

    const body = await response.json();
    return { status: response.status, body };
  }
}
